var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-dropdown",
    { staticClass: "entry-menus", attrs: { placement: "bottomCenter" } },
    [
      _vm.menu
        ? _c(
            "span",
            { staticClass: "entry-menus__name" },
            [
              _vm._v(" " + _vm._s(_vm._f("menuLocalName")(_vm.menu)) + " "),
              _c("a-icon", {
                staticStyle: { "margin-left": "5px", "font-size": "12px" },
                attrs: { type: "caret-down" }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { attrs: { slot: "overlay" }, slot: "overlay" },
        [
          _c(
            "div",
            {
              staticClass: "entry-menus__custom",
              staticStyle: { display: "none" }
            },
            [
              _c("div", { staticClass: "entry-menus__label" }, [
                _vm._v("常用菜单：")
              ]),
              _c(
                "div",
                { staticClass: "entry-menus__value" },
                [
                  _c("a-button", { attrs: { shape: "round", size: "small" } }, [
                    _vm._v("测试数据")
                  ]),
                  _c("a-button", { attrs: { shape: "round", size: "small" } }, [
                    _vm._v("测试数据")
                  ]),
                  _c("a-button", { attrs: { shape: "round", size: "small" } }, [
                    _vm._v("测试数据")
                  ]),
                  _c("a-button", { attrs: { shape: "round", size: "small" } }, [
                    _vm._v("测试数据")
                  ]),
                  _c("a-button", { attrs: { shape: "round", size: "small" } }, [
                    _vm._v("测试数据")
                  ])
                ],
                1
              )
            ]
          ),
          _c("entry-menus-item", {
            attrs: { menu: _vm.menu, currentLang: _vm.currentLang },
            on: { click: _vm.handleClick, pushpin: _vm.handlePushpin }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }